module.exports = __webpack_public_path__ + "img/40_35.191e1eac.png";